<div fxLayout="column" class="scrollable-box">
  <div fxLayout="row">
    <div fxFlex></div>
    <app-progressbar [step]="step" [maxStep]="maxStep"></app-progressbar>
  </div>
  <div class="step-title">
    {{ stepTitle }}
  </div>
  <div
    fxLayout="column"
    class="step-content"
    #scrollable
    (scroll)="scrollHelpers()"
    (window:resize)="scrollHelpers()"
    [ngClass]="{ scrollbarPadding: hasScrollbar }">
    <div class="scroll-shadow" [ngClass]="{ scrollBarVisible: hasScrollbar }" #scrollShadow></div>
    <div class="step-container" #stepContainer [ngSwitch]="step">
      <app-step-one fxFlex *ngSwitchCase="1"></app-step-one>
      <app-step-two fxFlex *ngSwitchCase="2"></app-step-two>
      <app-step-three fxFlex *ngSwitchCase="3"></app-step-three>
      <app-step-four fxFlex="100%" *ngSwitchCase="4"></app-step-four>
      <app-step-inner-walls fxFlex="100%" *ngSwitchCase="5"></app-step-inner-walls>
      <app-step-five fxFlex="100%" *ngSwitchCase="6"></app-step-five>
      <app-step-six fxFlex="100%" *ngSwitchCase="7"></app-step-six>
    </div>
    <div class="price-separator"></div>
  </div>
  <app-price-information></app-price-information>
  <app-step-buttons></app-step-buttons>
</div>
